;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('commentItem', commentItem)

  function commentItem () {
    return {
      restrict: 'E',
      scope: {
        comment: '=',
        onHover: '&',
        onBlur: '&',
        onEdit: '&',
        onPinnedChanges: '&',
        showIsPrivate: '<',
        showPinnedToolbar: '<',
        annotationOptions: '=',
        darkMode: '<'
      },
      templateUrl: '/core/directives/comment-item/comment-item-directive.html?$$REVISION$$',
      controller: 'CommentItemController'
    }
  }
})()
